import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class ServiceApi {
    static async getAllServices(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.SERVICE; // endpoint
        const requestModel = { storeId };
        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        } else {
            console.error('Failed to fetch services.');
            return [];
        }
    }

    // Create
    static async addNewService(data) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.SERVICE; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Service added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new service.');
        }
    }

    // Get by ID
    static async getServiceById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.SERVICE}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch service by ID');
        }
    }

    // Update 
    static async updateServiceById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.SERVICE}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Service updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update service.');
        }
    }

    // Delete 
    static async deleteService(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.SERVICE}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete service.');
            }
        } catch (error) {
            console.error('Error deleting service:', error);
            throw error;
        }
    }

    // Delete 
    static async deleteManyServices(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.SERVICE}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel.message, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.errormessage, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
